package com.dotdrives.web.pages.dashboard

import react.FC
import react.Props
import react.dom.html.ReactHTML.style

val DashboardStyles = FC<Props> {
    style {
        +"""
.dashboard-page {
    color: #222D32;
    max-width: 1400px;
    margin: auto;
}
.dashboard-intro {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 22px;
}
.dashboard-intro h1 {
    font: 700 24px Quicksand,sans-serif;
    margin: 0 0 5px;
}
.dashboard-intro p {
    color: #5A6870;
    font-size: 13px;
    margin: 0;
    max-width: 690px;
}
.dashboard-primary,.dashboard-secondary,.dashboard-page button {
    font: 800 12.5px 'Nunito Sans',sans-serif;
    cursor: pointer;
    border-radius: 99px;
    padding: 9px 15px;
    border: 1.5px solid #E4E8EC;
    background: white;
    color: #5A6870;
}
.dashboard-page .dashboard-primary,.dashboard-confirm .dashboard-primary {
    background: var(--dot-action);
    color: white;
    border-color: var(--dot-action);
}
.dashboard-page .dashboard-primary:hover:not(:disabled),.dashboard-confirm .dashboard-primary:hover:not(:disabled) { background: var(--dot-action-hover); color: white; border-color: var(--dot-action-hover); }
.dashboard-page button:disabled {
    opacity: .5;
    cursor: wait;
}
.dashboard-page button:focus-visible,.dashboard-confirm button:focus-visible {
    outline: 3px solid #4696EC;
    outline-offset: 3px;
}
.dashboard-upper {
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    gap: 18px;
    margin-bottom: 18px;
}
.dashboard-queue {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
}
.dashboard-move {
    border: 1px solid #E4E8EC;
    border-left: 6px solid #C22C25;
    background: white;
    border-radius: 16px;
    padding: 16px 20px;
}
.dashboard-move-gift {
    border-left-color: #F26223;
}
.dashboard-move-drive {
    border-left-color: #4696EC;
}
.dashboard-move-title {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}
.dashboard-rank {
    font: 700 18px Quicksand,sans-serif;
    color: var(--dot-muted);
}
.dashboard-move h2 {
    font-size: 15.5px;
    font-weight: 800;
    margin: 0;
    flex: 1;
}
.dashboard-badge {
    font: 800 10px 'Nunito Sans';
    background: #FDECEA;
    color: #C22C25;
    border-radius: 99px;
    padding: 3px 9px;
}
.dashboard-move-gift .dashboard-badge {
    background: #FDE5DA;
    color: var(--dot-action-text);
}
.dashboard-move-drive .dashboard-badge {
    background: #E4EEFB;
    color: #2B6CB8;
}
.dashboard-move p {
    font-size: 13px;
    line-height: 1.55;
    color: #5A6870;
    margin: 7px 0 11px;
}
.dashboard-move-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}
.dashboard-move-gift .dashboard-primary {
    background: #FDE5DA;
    color: var(--dot-action-text);
    border-color: #FDE5DA;
}
.dashboard-queue-foot {
    padding: 10px 16px;
    border: 1px dashed #D6DBE0;
    background: white;
    border-radius: 14px;
    color: #5A6870;
    font-size: 12px;
}
.dashboard-queue-foot button,.dashboard-attention button {
    border: 0;
    padding: 3px;
    color: var(--dot-action-text);
}
.dashboard-goal {
    background: #222D32;
    border-radius: 16px;
    color: white;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.dashboard-meta {
    font: 500 10px 'IBM Plex Mono';
    letter-spacing: 1px;
    color: #B6C2C9;
}
.dashboard-goal h2 {
    font: 700 20px Quicksand;
    margin: 0;
}
.dashboard-goal p {
    font-size: 12px;
    line-height: 1.5;
    color: #B6C2C9;
    margin: 0;
}
.dashboard-goal-number {
    font: 500 32px 'IBM Plex Mono';
    margin: 18px 0 8px;
    color: #F79E78;
}
.dashboard-goal-number small {
    font-size: 14px;
    color: white;
}
.dashboard-goal progress {
    width: 100%;
    height: 12px;
    accent-color: #F26223;
}
.dashboard-forecast {
    padding: 17px 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
}
.dashboard-forecast span,.dashboard-goal-details span {
    font: 500 10px 'IBM Plex Mono';
    letter-spacing: .5px;
    color: #B6C2C9;
}
.dashboard-forecast strong {
    font: 700 26px Quicksand;
    color: #F79E78;
}
.dashboard-goal-details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-top: auto;
}
.dashboard-goal-details>div {
    padding: 12px;
    background: #ffffff12;
    border-radius: 10px;
    display: flex;
    gap: 7px;
    flex-direction: column;
}
.dashboard-goal-details strong {
    font: 500 18px 'IBM Plex Mono';
}
.dashboard-asof {
    margin-top: 8px!important;
}
.dashboard-metrics {
    display: grid;
    grid-template-columns: repeat(4,minmax(0,1fr));
    gap: 16px;
    margin-bottom: 18px;
}
.dashboard-metric {
    background: white;
    border: 1px solid #E4E8EC;
    border-radius: 16px;
    padding: 16px 18px;
}
.dashboard-metric>span {
    font: 500 10px 'IBM Plex Mono';
    color: #5A6870;
    letter-spacing: 1px;
}
.dashboard-metric strong {
    display: block;
    font: 700 25px Quicksand;
    margin: 6px 0;
    color: #007942;
}
.dashboard-metric p {
    font-size: 11.5px;
    color: #5A6870;
    margin: 0;
}
.dashboard-attention {
    display: grid;
    grid-template-columns: repeat(3,minmax(0,1fr));
    gap: 16px;
}
.dashboard-attention-card {
    padding: 18px 20px;
    border-radius: 16px;
    background: white;
    border: 1px solid #E4E8EC;
}
.dashboard-attention h2 {
    font: 700 15px Quicksand;
    display: flex;
    justify-content: space-between;
    margin: 0 0 12px;
}
.dashboard-attention h2 span {
    background: #FDE5DA;
    color: var(--dot-action-text);
    border-radius: 99px;
    padding: 3px 10px;
    font: 800 11px 'Nunito Sans';
}
.dashboard-attention-row {
    display: flex;
    gap: 10px;
    justify-content: space-between;
    font-size: 12px;
    padding: 8px 0;
    border-bottom: 1px solid #EFF1F4;
}
.dashboard-attention-row small {
    font: 400 10px 'IBM Plex Mono';
    white-space: nowrap;
    color: #5A6870;
}
.dashboard-attention button {
    margin-top: 12px;
}
.dashboard-empty {
    padding: 30px;
    text-align: center;
    border: 1px solid #E4E8EC;
    border-radius: 16px;
    background: white;
}
.dashboard-empty>span {
    font-size: 36px;
    color: var(--dot-positive);
}
.dashboard-empty h2 {
    font: 700 21px Quicksand;
}
.dashboard-empty p {
    font-size: 13px;
    color: #5A6870;
}
.dashboard-mobile-pace {
    display: none;
}
.dashboard-loading {
    display: grid;
    gap: 14px;
}
.dashboard-confirm {
    position: fixed;
    inset: 0;
    z-index: 1000;
    background: #222d3277;
    display: grid;
    place-items: center;
    padding: 18px;
}
.dashboard-confirm-card {
    max-width: 440px;
    background: white;
    padding: 24px;
    border-radius: 20px;
}
.dashboard-confirm-card h2 {
    font: 700 22px Quicksand;
}
.dashboard-confirm-card p {
    line-height: 1.6;
}
.dashboard-confirm-card button {
    margin-right: 8px;
}
@media(max-width:700px) {
    .portal-shell:has(.dashboard-page) .portal-topbar {
        display: none;
    }
    .portal-shell:has(.dashboard-page) .portal-content {
        padding: 0;
    }
    .dashboard-intro {
        padding: 18px 20px 20px;
        background: #222D32;
        color: white;
        display: block;
        margin: 0 0 14px;
    }
    .dashboard-intro h1 {
        font-size: 20px;
    }
    .dashboard-intro>div>p {
        display: none;
    }
    .dashboard-intro>button {
        display: none;
    }
    .dashboard-mobile-pace {
        margin-top: 14px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        background: #ffffff12;
        border-radius: 12px;
        padding: 12px 14px;
    }
    .dashboard-mobile-pace span {
        font: 400 9px 'IBM Plex Mono';
        color: #B6C2C9;
        letter-spacing: 1px;
    }
    .dashboard-mobile-pace strong {
        font: 700 16px Quicksand;
        color: #F79E78;
    }
    .dashboard-upper {
        display: block;
        margin: 0 16px 16px;
    }
    .dashboard-move {
        padding: 13px 15px;
        border-left-width: 5px;
        border-radius: 14px;
    }
    .dashboard-move h2 {
        font-size: 13.5px;
    }
    .dashboard-rank {
        font-size: 17px;
    }
    .dashboard-badge {
        display: none;
    }
    .dashboard-move p {
        font-size: 12px;
    }
    .dashboard-move button {
        font-size: 11.5px;
        padding: 7px 12px;
    }
    .dashboard-goal {
        margin-top: 16px;
        padding: 18px;
    }
    .dashboard-goal-number {
        font-size: 25px;
        margin: 7px 0;
    }
    .dashboard-forecast {
        padding: 6px 0;
    }
    .dashboard-metrics {
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        margin: 0 16px 16px;
    }
    .dashboard-metric {
        padding: 13px 14px;
        border-radius: 14px;
    }
    .dashboard-metric strong {
        font-size: 19px;
    }
    .dashboard-metric>span {
        font-size: 9.5px;
        letter-spacing: .3px;
    }
    .dashboard-attention {
        grid-template-columns: 1fr;
        margin: 0 16px 16px;
        gap: 10px;
    }
    .dashboard-queue-foot {
        font-size: 11px;
    }
    .dashboard-intro p {
        color: #B6C2C9;
    }
}
        """
    }
}
